import { useMatch } from '../MatchProvider';
import { MatchCellButton } from './MatchCellIButton';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { useMatchDrawer } from 'src/hooks/useMatchDrawer';
import { Team } from 'functions/src/types/firestore/Game/Tournament/Guestlist';

export type CellButtonRefereeProps = {
  gameId: string;
  tournamentId: string;
  team1: Team<Date>;
  team2: Team<Date>;
};

export const CellButtonReferee: React.FC<CellButtonRefereeProps> = ({
  gameId,
  tournamentId,
  team1,
  team2,
}) => {
  const match = useMatch();

  const { openMatchDrawer } = useMatchDrawer({
    gameId,
    tournamentId,
  });

  return (
    <MatchCellButton
      Icon={EditRoundedIcon}
      onClick={() => {
        return openMatchDrawer({
          match: { ...match, team1, team2 },
        });
      }}
    />
  );
};
